import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form, message } from 'antd';

const OfflineProvider = (props) => {
  const api = new API();
  const [offStudentList, setOffStudentList] = useState([]);
  const [offStudentListLoading, setOffStudentListLoading] = useState(false);
  const [offCategoryList, setOffCategoryList] = useState([]);
  const [offCategoryListLoading, setOffCategoryListLoading] = useState(false);
  const [offSubCategoryList, setOffSubCategoryList] = useState([]);
  const [offSubCategoryListLoading, setOffSubCategoryListLoading] = useState(false);
  const [paymentFormData, setPaymentFormData] = useState({
    student_type: "",
    student_id: "",
    s_name: "",
    s_phone: "",
    s_email: "",
    s_migrated: "",
    c_sub_id: "",
    c_plan: "",
    c_duration: "",
    c_start_date: "",
    c_expiry_date: "",
    c_amount: "",
    c_migrated: "",
    c_extra_duration: "",
    c_expiry_none: "",
    p_mode: "",
    p_migrated: "",
    p_custom_plan: "",
    p_plan: "",
    p_duration: "",
    payment_on: false,
    p_expiry_none: "",
    np_category: "",
    np_subcategory: "",
    np_product: "",
    np_amount: "",
    np_year: "",
    np_month: "",
    np_days: "",
    np_expiry_none: "",
    p_amount: "",
    p_payment_id: "",
    p_payment_method: "",
  });
  const [getCurrentPlan, setCurrentPlan] = useState({});
  const [getCurrentPlanLoading, setCurrentPlanLoading] = useState(false);
  const [paymentForm] = Form.useForm();
  const [offPlanList, setOffPlanList] = useState([]);
  const [offPlanListLoading, setOffPlanListLoading] = useState(false);
  const [durationList, setDurationList] = useState([]);
  const [createOffLinePaymentLoader, setCreateOffLinePaymentLoader] = useState(false);

  const offLinePayment = async (data) => {
    setCreateOffLinePaymentLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("offline/offlinepaymentcreate", {...data}, (err, res) => {
        if (res?.data?.status === 200) {
          message.success(res?.data?.message);
          paymentForm.resetFields();
          setPaymentFormData({
            student_type: "new",
            student_id: "",
            s_name: "",
            s_phone: "",
            s_email: "",
            s_migrated: "",
            c_sub_id: "",
            c_plan: "",
            c_duration: "",
            c_start_date: "",
            c_expiry_date: "",
            c_amount: "",
            c_migrated: "",
            c_extra_duration: "",
            c_expiry_none: "",
            p_mode: "",
            p_migrated: "",
            p_custom_plan: "no",
            p_plan: "",
            payment_on: false,
            p_duration: "",
            p_expiry_none: "",
            np_category: "",
            np_subcategory: "",
            np_product: "",
            np_amount: "",
            np_year: "",
            np_month: "",
            np_days: "",
            np_expiry_none: "",
            p_amount: "",
            p_payment_id: "",
            p_payment_method: "",
          });
          paymentForm.setFieldsValue({
            student_type: "new",
            p_custom_plan: "no",
          })
        } else {
          message.error(err?.response?.data?.message);
        }
        setCreateOffLinePaymentLoader(false);
      }));
  }
  const fetchOffPlanList = async (id) => {
    setOffPlanListLoading(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("offline/offlinegetplan", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setOffPlanList(res?.data?.data);
        } else {
          setOffPlanList([]);
        }
        setOffPlanListLoading(false);
      }));
  }

  const fetchOfflineCurrentPlan = async (id) => {
    setCurrentPlanLoading(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("offline/offlinegetsubusers", { user_id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setCurrentPlan(res?.data?.data);
          paymentForm.setFieldsValue({
            c_start_date: res?.data?.data?.validity_from,
            c_expiry_date: res?.data?.data?.validity_to,
            c_duration: res?.data?.data?.duration,
            c_migrated: res?.data?.data?.migrated == 1 ? "Yes" : "No",
            c_extra_duration: res?.data?.data?.extra_days || 0,
            c_expiry_none: res?.data?.data?.expiry===0?"No":"Yes" || "yes",
          });
        } else {
          setCurrentPlan([]);
        }
        setCurrentPlanLoading(false);
      }));
  }
  const fetchOfflineSubCategoryList = async (id) => {
    setOffSubCategoryListLoading(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("offline/offlinegetsubcategory", { category_id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setOffSubCategoryList(res?.data?.data);
        } else {
          setOffSubCategoryList([]);
        }
        setOffSubCategoryListLoading(false);
      }));
  }
  const fetchOfflineCategoryList = async () => {
    setOffCategoryListLoading(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("offline/offlinegetcategory", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setOffCategoryList(res?.data?.data);
        } else {
          setOffCategoryList([]);
        }
        setOffCategoryListLoading(false);
      }));
  }

  const fetchOfflineStudentList = async () => {
    setOffStudentListLoading(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("offline/offlineslist", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setOffStudentList(res?.data?.data);
        }
        setOffStudentListLoading(false);
      }));
  }

  return (
    <Context.Provider value={{
      ...props,
      offStudentList, setOffStudentList,
      offStudentListLoading, setOffStudentListLoading,
      fetchOfflineStudentList,
      offCategoryList, setOffCategoryList,
      offCategoryListLoading, setOffCategoryListLoading,
      fetchOfflineCategoryList,
      offSubCategoryList, setOffSubCategoryList,
      offSubCategoryListLoading, setOffSubCategoryListLoading,
      fetchOfflineSubCategoryList,
      paymentFormData, setPaymentFormData,
      paymentForm,
      getCurrentPlan, setCurrentPlan,
      getCurrentPlanLoading, setCurrentPlanLoading,
      fetchOfflineCurrentPlan,
      offPlanList, setOffPlanList,
      offPlanListLoading, setOffPlanListLoading,
      fetchOffPlanList,
      durationList, setDurationList,
      createOffLinePaymentLoader, setCreateOffLinePaymentLoader,
      offLinePayment,
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default OfflineProvider;

